// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2pGYV","title":"BackImages_title__2rfD4","images":"BackImages_images__3dwNU"};